import { render, staticRenderFns } from "./ConversationFormSend.vue?vue&type=template&id=4cf2ae7a&scoped=true&"
import script from "./conversation-form-send.ts?vue&type=script&lang=ts&"
export * from "./conversation-form-send.ts?vue&type=script&lang=ts&"
import style0 from "./ConversationFormSend.vue?vue&type=style&index=0&id=4cf2ae7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2ae7a",
  null
  
)

export default component.exports